import { LANG, LANGACTUALL } from '@models/entities/general/lang';

// TODO - delete
export const LANGS: Array<LANG> = [
  {
    id: 0,
    key: 'en',
    title: 'language.english',
    icon: '/assets/img/flags/us.svg'
  },
  {
    id: 1,
    key: 'es',
    title: 'language.spanish',
    icon: '/assets/img/flags/cr.svg'
  }
];

export const AVAILABLELANGUAGES = [
  {
    code: 'en',
    name: 'language.english',
    icon: './assets/img/flags/us.svg',
    selected: true,
    value: 0,
  },
  {
    code: 'es',
    name: 'language.spanish',
    icon: './assets/img/flags/cr.svg',
    selected: false,
    value: 1,
  },
];

export const AVAILABLELANGUAGES_ES = [
  {
    code: 'en',
    name: 'language.english',
    icon: './assets/img/flags/us.svg',
    selected: false,
    value: 0,
  },
  {
    code: 'es',
    name: 'language.spanish',
    icon: './assets/img/flags/cr.svg',
    selected: true,
    value: 1,
  },
];

export const objLangs = {
  es: AVAILABLELANGUAGES_ES,
  en: AVAILABLELANGUAGES,
};

export const defaultLanguage = 'es';

export const LANGACTUAL: LANGACTUALL = {
  icon: '/assets/img/flags/cr.svg',
  langName: 'language.spanish',
  langValue: 1
};
